// header-scroll.js - Homepage only (Dawn)
// toggles .header-solid on the header when hero is out of view
(function () {
  document.addEventListener('DOMContentLoaded', function () {
    // quick homepage guard: Dawn adds template-index class to body for homepage
    var isHomepage = document.body.classList.contains('template-index') || window.location.pathname === '/';
    if (!isHomepage) return; // do nothing except on homepage

    var header = document.querySelector('.header-wrapper') || document.querySelector('header');
    if (!header) return;

    // Add an explicit "transparent" class initially so CSS doesn't rely on body.template-index
    header.classList.add('header-transparent');

    // Optional: logo <img> swap (uncomment use by adding data attributes to your logo img)
    // <img src="{{ 'logo-dark.png' | asset_url }}" data-logo-dark="{{ 'logo-dark.png' | asset_url }}" data-logo-light="{{ 'logo-white.png' | asset_url }}" alt="Logo" />
    var logoImg = header.querySelector('img[data-logo-dark][data-logo-light]') || null;
    function setLogoToLight() {
      if (logoImg) {
        logoImg.src = logoImg.getAttribute('data-logo-light');
        logoImg.classList.remove('logo-dark');
        logoImg.classList.add('logo-light');
        return;
      }
      // fallback: if logo is an <img> without data attributes, invert it visually
      var rawImg = header.querySelector('.header__heading-logo img');
      if (rawImg) rawImg.classList.add('logo-light-fallback');
    }
    function setLogoToDark() {
      if (logoImg) {
        logoImg.src = logoImg.getAttribute('data-logo-dark');
        logoImg.classList.remove('logo-light');
        logoImg.classList.add('logo-dark');
        return;
      }
      var rawImg = header.querySelector('.header__heading-logo img');
      if (rawImg) rawImg.classList.remove('logo-light-fallback');
    }

    // hero selectors (covers common Dawn hero/slideshow markup)
    var heroSelectorList = [
      '[data-section-type="slideshow"]',
      '[data-section-type="hero"]',
      '.slideshow',
      '.hero',
      '.section--hero',
      '.slideshow__wrapper',
      '.hero__media'
    ];
    var hero = null;
    for (var i = 0; i < heroSelectorList.length; i++) {
      hero = document.querySelector(heroSelectorList[i]);
      if (hero) break;
    }

    var addSolid = function () {
      header.classList.add('header-solid');
      header.classList.remove('header-transparent');
      setLogoToDark();
    };
    var removeSolid = function () {
      header.classList.remove('header-solid');
      header.classList.add('header-transparent');
      setLogoToLight();
    };

    if (hero) {
      var observer = new IntersectionObserver(function (entries) {
        if (entries[0].isIntersecting) {
          // hero visible -> transparent header
          removeSolid();
        } else {
          // hero not visible -> solid header
          addSolid();
        }
      }, {
        root: null,
        rootMargin: '-1px 0px 0px 0px',
        threshold: 0
      });
      observer.observe(hero);
    } else {
      // fallback: toggle based on scroll distance
      var threshold = 60;
      var lastKnown = 0;
      var ticking = false;

      var onScroll = function () {
        lastKnown = window.scrollY || window.pageYOffset;
        if (!ticking) {
          window.requestAnimationFrame(function () {
            if (lastKnown > threshold) addSolid(); else removeSolid();
            ticking = false;
          });
          ticking = true;
        }
      };
      window.addEventListener('scroll', onScroll, { passive: true });
      // initialize
      if (window.scrollY > threshold) addSolid(); else removeSolid();
    }

    // Initialize logo state immediately
    setLogoToLight();
  });
})();
